import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { MotivoDesativacao } from "../models/dominios";
import { SolicitacaoDesativacao } from "../models/solicitacao-desativacao";
import { DataUtil } from "../utils/data-util";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class EstabelecimentoService {
  constructor(private http: HttpClient, private baseService: BaseService) {}

  async getEstabelecimentoById(id: number | string) {
    const url = `/cnes/estabelecimentos/${id}`;
    return this.baseService.get(url).toPromise();
  }

  async listarSolicitacaoPorStatus(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = "DESC",
    atributoOrdenacao: string = "DATA_SOLICITACAO"
  ) {
    let url =
      environment.urlBaseNova +
      "/cnes/alteracoes-status?pagina=" +
      pageNumber +
      "&tamanho-pagina=" +
      pageSize +
      "&direcao-ordenacao=" +
      direcaoOrdenacao +
      "&ordenacao=" +
      atributoOrdenacao +
      "&status=SOLICITADA";
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + "&conteudo-livre=" + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async listarEstabelecimentosPorStatus(
    status: string,
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = "DESC",
    atributoOrdenacao: string = "CNES"
  ) {
    let url =
      environment.urlBaseNova +
      "/cnes/estabelecimentos?pagina=" +
      pageNumber +
      "&tamanho-pagina=" +
      pageSize +
      "&direcao-ordenacao=" +
      direcaoOrdenacao +
      "&ordenacao=" +
      atributoOrdenacao +
      "&status=" +
      status;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + "&conteudoLivre=" + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async aceitarReativacao(id) {
    const url = "/cnes/estabelecimentos/" + id + "/reativar";
    const response: any = await this.baseService.put(url, {
      idEstabelecimento: id,
    });
    return response;
  }

  async solicitarReativarSus(id) {
    const url = `${environment.urlBaseNova}/cnes/alteracoes-status/solicitar-reativacao-sus`;
    return await this.http
      .post(url, {
        idEstabelecimento: id,
        sus: true,
      })
      .toPromise();
  }

  async solicitarReativarNSus(id) {
    const url = `${environment.urlBaseNova}/cnes/alteracoes-status/solicitar-reativacao-nao-sus`;
    return await this.http
      .post(url, {
        idEstabelecimento: id,
        sus: false,
      })
      .toPromise();
  }

  async reativar(id) {
    const url = `${environment.urlBaseNova}/cnes/estabelecimentos/${id}/reativar`;
    return await this.http.put(url, {}).toPromise();
  }

  async rejeitarDesativacao(id, cnes, motivo: MotivoDesativacao) {
    const url = "/estabelecimento/rejeitar-desativacao";
    const response: any = await this.baseService.post(url, {
      id,
      cnes,
      descricaoJustificativa: motivo.descricao,
      codMotivoDesabilitacao: motivo.codigo,
      dataNegativaRejeicao: DataUtil.getDataEHoraAtualComoString(),
    });
  }

  async solicitarDesativarSus(
    id,
    cnes,
    codMotivoDesabilitacao,
    motivoDesabilitacao,
    dataSolicitacaoDesativacao,
    dataAtendimento
  ) {
    const url =
      environment.urlBaseNova +
      "/cnes/alteracoes-status/solicitar-desativacao-sus";
    const response: any = await this.http
      .post(url, {
        codigoMotivoDesativacao: codMotivoDesabilitacao,
        idEstabelecimento: id,
        sus: true,
      })
      .toPromise();
    return response;
  }

  async solicitarDesativarNSus(
    id,
    cnes,
    codMotivoDesabilitacao,
    motivoDesabilitacao,
    dataSolicitacaoDesativacao,
    dataAtendimento
  ) {
    const url =
      environment.urlBaseNova +
      "/cnes/alteracoes-status/solicitar-desativacao-nao-sus";
    const response: any = await this.http
      .post(url, {
        codigoMotivoDesativacao: codMotivoDesabilitacao,
        idEstabelecimento: id,
        sus: false,
      })
      .toPromise();
    return response;
  }
  async desativar(id, codMotivoDesabilitacao) {
    const url =
      environment.urlBaseNova + "/cnes/estabelecimentos/" + id + "/desativar";
    const response: any = await this.http
      .put(url, {
        codigoMotivoDesativacao: codMotivoDesabilitacao,
        "id-estabelecimento": id,
      })
      .toPromise();
    return response;
  }

  async buscarPorCNES(cnes) {
    const estabelecimentos = [
      {
        cnes: "5701929",
        nomeFantasia: "UNIDADE MISTA DE SAUDE DE ACRELANDIA",
        razaoSocial: "SECRETARIA DE ESTADO DE SAUDE",
        uf: "DF",
        municipio: "Brasília",
        tipoEstabelecimento: "",
      },
      {
        cnes: "0010456",
        nomeFantasia: "INSTITUTO HOSPITAL DE BASE DO DISTRITO FEDERAL",
        razaoSocial: "INSTITUTO HOSPITAL DE BASE DO DISTRITO FEDERAL IHBDF",
        uf: "DF",
        municipio: "Brasília",
        tipoEstabelecimento: "",
      },
    ];

    return estabelecimentos.find((e) => e.cnes === cnes);
  }

  async listarEstabelecimentosCadastrados(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = "DESC",
    atributoOrdenacao: string = "CNES"
  ) {
    let url =
      environment.urlBaseNova +
      "/cnes/estabelecimentos?pagina=" +
      pageNumber +
      "&tamanho-pagina=" +
      pageSize +
      "&direcao-ordenacao=" +
      direcaoOrdenacao +
      "&ordenacao=" +
      atributoOrdenacao;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + "&conteudoLivre=" + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async listarEstabelecimentosRascunhos(
    pageNumber: any = 1,
    pageSize: any = 5,
    conteudoLivre?: string,
    direcaoOrdenacao: string = "DESC",
    atributoOrdenacao: string = "CNES"
  ) {
    let url =
      environment.urlBaseNova +
      "/cnes/estabelecimentos/rascunhos?pagina=" +
      pageNumber +
      "&tamanho-pagina=" +
      pageSize +
      "&direcao-ordenacao=" +
      direcaoOrdenacao +
      "&ordenacao=" +
      atributoOrdenacao;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + "&conteudoLivre=" + conteudoLivre;
    }
    return await this.http.get(url).toPromise();
  }

  async listarEstabelecimentosRascunhosEmAnalise(
    pageNumber: any = 0,
    pageSize: any = 5,
    conteudoLivre?: string,
    tipoEstabelecimento?: string,
    novoCadastro?: string,
    cadastroAtualizado?: string,
    semAlteracao?: string,
    direcaoOrdenacao: string = "DESC",
    atributoOrdenacao: string = "CNES"
  ) {
    let url =
      environment.urlBaseNova +
      "/cnes/estabelecimentos/rascunhos-em-analise?pagina=" +
      pageNumber +
      "&tamanho-pagina=" +
      pageSize +
      "&direcao-ordenacao=" +
      direcaoOrdenacao +
      "&ordenacao=" +
      atributoOrdenacao;
    if (conteudoLivre && conteudoLivre.trim()) {
      url = url + "&conteudoLivre=" + conteudoLivre;
    }
    if (tipoEstabelecimento && tipoEstabelecimento.trim()) {
      url = url + "&tipo-estabelecimento=" + tipoEstabelecimento;
    }

    if (novoCadastro && novoCadastro.trim()) {
      url = url + "&novo-cadastro=" + novoCadastro;
    }

    if (cadastroAtualizado && cadastroAtualizado.trim()) {
      url = url + "&cadastro-atualizado=" + cadastroAtualizado;
    }

    if (semAlteracao && semAlteracao.trim()) {
      url = url + "&sem-alteracao=" + semAlteracao;
    }

    return await this.http.get(url).toPromise();
  }

  listaAnalise() {
    return this.http.get("./assets/dados-fake/lista-analise.json").toPromise();
  }

  listaPendenciasAnalise() {
    return this.http
      .get("./assets/dados-fake/lista-analise-pendencias.json")
      .toPromise();
  }

  /**
   * Mock
   */
  verificarOcorrencias(): Promise<Array<AbaAnalise>> {
    return new Promise((resolve) => {
      resolve([
        {
          nome: "Identificação",
          nomeIcon: "ico-identificacao",
          hasAlerta: true,
          quantidadeAlerta: 3,
          ocorrencias: [
            {
              titulo: "Impedimento",
              descricao:
                "1194 - Tipo de estrutura incompatível com tipo de estabelecimento",
              data: new Date(),
              tipo: "erro",
            },
            {
              titulo: "Impedimento",
              descricao: "0080 - Falta Profissionais para a Classificação",
              data: new Date(),
              tipo: "erro",
            },
            {
              titulo: "Advertência",
              descricao: "1225 - Localização geográfica não preenchida",
              data: new Date(),
              tipo: "atencao",
            },
            {
              titulo: "Corrigido",
              descricao: "1182 - Estabelecimento sem horário de funcionamento",
              data: new Date(),
              tipo: "sucesso",
            },
          ],
        },
        {
          nome: "Caracterização",
          nomeIcon: "ico-caracterizacao",
          hasAlerta: true,
          quantidadeAlerta: 1,
          ocorrencias: [
            {
              titulo: "Título da Ocorrência",
              descricao: "Descricao",
              data: new Date(),
              tipo: "atencao",
            },
          ],
        },
        {
          nome: "Recursos Fisicos",
          nomeIcon: "ico-recursos-fisicos",
          hasAlerta: false,
          quantidadeAlerta: 0,
        },
        {
          nome: "Recursos Humanos",
          nomeIcon: "ico-recursos-humanos",
          hasAlerta: false,
          quantidadeAlerta: 0,
        },
      ]);
    });
  }

  async buscarEquipesEstabelecimento(
    idEstabelecimento,
    pagina = 0,
    tamanhoPagina = 3
  ) {
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/equipes?pagina=${pagina}&tamanho-pagina=${tamanhoPagina}`;
    return await this.baseService.get(url).toPromise();
  }

  async buscarEstabelecimentoByCnes(codigoCnes) {
    const url = `/cnes/estabelecimentos/cnes/${codigoCnes}`;
    return await this.baseService.get(url).toPromise();
  }

   async buscarEstabelecimentoByCnesFiltroScpa(codigoCnes) {
    const url = `/cnes/estabelecimentos/cnes/${codigoCnes}/filtro`;
    return await this.baseService.get(url).toPromise();
  }

  async getByTipoEquipe(idTipoEquipe) {
    const url = `/cnes/estabelecimentos/tipo-equipe/${idTipoEquipe}`;
    return await this.baseService.get(url).toPromise();
  }

  async aceitarReativacaoEstabelecimento(idAlteracao, justificativa) {
    const url = `cnes/alteracoes-status/${idAlteracao}/aceitar-reativacao`;
    return await this.baseService.put(url, {
      justificativa,
    });
  }

  async aceitarDesativacao(idAlteracao, justificativa) {
    const url = `cnes/alteracoes-status/${idAlteracao}/aceitar-desativacao`;
    return await this.baseService.put(url, {
      justificativa,
    });
  }

  async rejeitarReativacao(idAlteracao, justificativa) {
    const url = `cnes/alteracoes-status/${idAlteracao}/rejeitar-reativacao`;
    return await this.baseService.put(url, {
      justificativa,
    });
  }

  async rejeitarDesativacaoEstabelecimento(idAlteracao, justificativa) {
    const url = `cnes/alteracoes-status/${idAlteracao}/rejeitar-desativacao`;
    return await this.baseService.put(url, {
      justificativa,
    });
  }

  async getVinculos(id) {
    const url = `${environment.urlBaseNova}/cnes/entidades-administradoras/${id}/vinculo`;
    return this.http.get(url).toPromise();
  }

  async getLeitosPainelPaginados(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = "ASC",
    atributoOrdenacao: string = "DETALHAMENTO"
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      "direcao-ordenacao": direcaoOrdenacao,
      ordenacao: atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/leitos?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getServicosEspecializadosPaginados(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = "ASC",
    atributoOrdenacao: string = "DETALHAMENTO"
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      "direcao-ordenacao": direcaoOrdenacao,
      ordenacao: atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/servicos-especializados/paginado?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getMarcacoesPaginados(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = "ASC",
    atributoOrdenacao: string = "DETALHAMENTO"
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      "direcao-ordenacao": direcaoOrdenacao,
      ordenacao: atributoOrdenacao,
      "id-estabelecimento": idEstabelecimento,
    });
    const url = `/cnes/marcacoes?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getEquipamentosPaginados(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = "ASC",
    atributoOrdenacao: string = "EQUIPAMENTO"
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      "direcao-ordenacao": direcaoOrdenacao,
      ordenacao: atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/equipamentos?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getProfissionaisPaginados(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5
    // direcaoOrdenacao: string = 'ASC',
    // atributoOrdenacao: string = 'CNS',
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      // 'direcao-ordenacao': direcaoOrdenacao,
      // 'ordenacao': atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/profissionais?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getProfissionaisPaginadosPainel(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = 'ASC',
    atributoOrdenacao: string = 'CNS',
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      'direcao-ordenacao': direcaoOrdenacao,
      'ordenacao': atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/profissionais/paginado?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getInstalacoesFisicasPaginadas(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = "ASC",
    atributoOrdenacao: string = "INSTALACAO"
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      "direcao-ordenacao": direcaoOrdenacao,
      ordenacao: atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/instalacoes-fisicas?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }

  async getEquipesPaginado(
    idEstabelecimento,
    pageNumber: any = 0,
    pageSize: any = 5,
    direcaoOrdenacao: string = "ASC",
    atributoOrdenacao: string = "DATA_ATIVACAO"
  ) {
    const urlParams = new URLSearchParams({
      pagina: pageNumber,
      "tamanho-pagina": pageSize,
      "direcao-ordenacao": direcaoOrdenacao,
      ordenacao: atributoOrdenacao,
    });
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/equipes?${urlParams.toString()}`;
    return this.baseService.get(url).toPromise();
  }


  async getEstabelecimentoCaracterizacao(idEstabelecimento) {
    const url = `/cnes/estabelecimentos/${idEstabelecimento}/caracterizacao`;
    return this.baseService.get(url).toPromise();
  }

  async getEquipesPorProfissional(
    cpf, cbo, idEstabelecimento
  ) {
    const url = '/cnes/consulta/equipes/estabelecimento/lista-por-profissional?';
    const params = new URLSearchParams({
      cpf, cbo, idEstabelecimento
    }).toString();
    return await this.baseService.get(url+params).toPromise();
  }
}
